import Vue from 'vue';

Vue.component('report-summary-flowrate-index', () =>
    import(/* webpackChunkName: 'report-summary-flowrate-index' */ './report-summary-flowrate-index'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/summary-flowrate/index.js